import analysisModule from "./analysisModule"
import template from "./nlgAnalysisViewButton.html"

analysisModule.directive("nlgAnalysisViewButton", ["planningUserPreferencesService", (planningUserPreferencesService) => {
    return {
        restrict: "E",
        template,
        scope: {
            viewType: "=",
            deliveryUnitType: "@",
            orderType: "@",
            type: "@"
        },
        controller: ["$scope", function ($scope) {

            $scope.viewType = {
                currentView: planningUserPreferencesService.getAnalysisViewTypePreferences($scope.type),
                possibleViews: [getBasketViewType(), getOrderViewType()]
            }

            function getBasketViewType() {
                return {
                    key: $scope.deliveryUnitType,
                    type: {
                        keyBundle: "br.com.neolog.service.presentationtree.viewType.delivery.unit"
                    }
                }
            }

            function getOrderViewType() {
                return {
                    key: $scope.orderType,
                    type: {
                        keyBundle: "br.com.neolog.service.presentationtree.viewType.order"
                    }
                }
            }

            $scope.changeCurrentViewType = (selectedViewType) => {
                $scope.viewType.currentView = selectedViewType
                planningUserPreferencesService.saveAnalysisViewTypePreferences(selectedViewType, $scope.type)
            }
        }]
    }
}])